import { render, staticRenderFns } from "./AddOpening.vue?vue&type=template&id=72121023&scoped=true"
import script from "./AddOpening.vue?vue&type=script&lang=js"
export * from "./AddOpening.vue?vue&type=script&lang=js"
import style0 from "./AddOpening.vue?vue&type=style&index=0&id=72121023&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72121023",
  null
  
)

export default component.exports